import { createContext } from 'react';
import UserPersonaTypes from '../constants/UserPersonaTypes';

const UserContext = createContext<UserPersonaTypes | null>(null);

export default UserContext;